export const getCookie = (name) => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const eqIndex = cookie.indexOf("=");
      if (eqIndex === -1) continue;
      const cookieName = cookie.substring(0, eqIndex).trim();
      const cookieValue = cookie.substring(eqIndex + 1);
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  };